// Assignments Module Initialization
// This file contains all side effects for the assignments module.
// It is imported by src/imports.ts at application startup.

import {ASSIGNMENT_DETAILS, ASSIGNMENTS_VIEW, ASSIGNMENTS_VIEW2} from '@/assignments'
import { registerRoute } from '@/router'
import { NavGroup, registerNavigationEntry } from '@/navigation'
import { useBreadCrumbs } from '@/breadcrumbs/useBreadCrumbs'

const { buildSimpleCrumb } = useBreadCrumbs()
const assignments_view_label = 'Oppgaver'
const icon = 'i-ph-list-fill'

// ASSIGNMENTS_VIEW
registerRoute(ASSIGNMENTS_VIEW)

// ASSIGNMENTS_VIEW2
registerRoute(ASSIGNMENTS_VIEW2)

registerRoute(ASSIGNMENT_DETAILS)

// Navigation Entry
registerNavigationEntry(NavGroup.MISC, {
    title: assignments_view_label,
    icon: 'i-ph-list-bullets',
    key: 'assignments',
    target: ASSIGNMENTS_VIEW,
})

registerNavigationEntry(NavGroup.MISC, {
    title: assignments_view_label + '(NY)',
    icon: 'i-ph-list-bullets',
    key: 'assignments2',
    target: ASSIGNMENTS_VIEW2,
})

// Breadcrumb
buildSimpleCrumb(ASSIGNMENTS_VIEW, assignments_view_label, icon)
